/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//   Generated using Swaggie (https://github.com/yhnavein/swaggie)
//   Please avoid doing any manual changes in this file
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// deno-lint-ignore-file

import Axios, { type AxiosPromise, type AxiosRequestConfig } from 'axios';

export const axios = Axios.create({
  baseURL: 'http://localhost:5101',
  paramsSerializer: (params: any) =>
    encodeParams(params, null, {
      allowDots: true,
      arrayFormat: 'repeat',
    }),
});

export const subscriptionClient = {
  /**
   * @param createPortalSessionRequest (API name: CreatePortalSessionRequest)
   * @param serviceVendorId
   */
  createPortalSessionEndpoint(
    createPortalSessionRequest: CreatePortalSessionRequest,
    serviceVendorId: ServiceVendorId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<CreatePortalSessionResponse> {
    const url = `/api/subscription/${encodeURIComponent(`${serviceVendorId}`)}/portal`;

    return axios.request<CreatePortalSessionResponse>({
      url: url,
      method: 'POST',
      data: createPortalSessionRequest,
      ...$config,
    });
  },

  /** @param serviceVendorId */
  getPricingConfigEndpoint(serviceVendorId: ServiceVendorId, $config?: AxiosRequestConfig): AxiosPromise<GetPricingConfigResponse> {
    const url = `/api/subscription/${encodeURIComponent(`${serviceVendorId}`)}/pricing-config`;

    return axios.request<GetPricingConfigResponse>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /** @param serviceVendorId */
  getVendorSubscriptionEndpoint(serviceVendorId: ServiceVendorId, $config?: AxiosRequestConfig): AxiosPromise<GetVendorSubscriptionResponse> {
    const url = `/api/subscription/${encodeURIComponent(`${serviceVendorId}`)}`;

    return axios.request<GetVendorSubscriptionResponse>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
};

export const serviceVendorsClient = {
  /**
   * @param serviceVendorId
   * @param employeeId
   */
  connectGoogleCalendarEndpoint(
    serviceVendorId: ServiceVendorId,
    employeeId: EmployeeId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<ConnectGoogleCalendarResponse> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/employees/${encodeURIComponent(`${employeeId}`)}/calendar/connect`;

    return axios.request<ConnectGoogleCalendarResponse>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param businessHoursId
   */
  deleteBusinessHoursEndpoint(
    serviceVendorId: ServiceVendorId,
    businessHoursId: ServiceVendorBusinessHoursId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/business-hours/${encodeURIComponent(`${businessHoursId}`)}`;

    return axios.request<unknown>({
      url: url,
      method: 'DELETE',
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param employeeId
   */
  deleteEmployeeEndpoint(serviceVendorId: ServiceVendorId, employeeId: EmployeeId, $config?: AxiosRequestConfig): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/employees/${encodeURIComponent(`${employeeId}`)}`;

    return axios.request<unknown>({
      url: url,
      method: 'DELETE',
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param employeeId
   * @param externalReservationId
   */
  deleteExternalReservationEndpoint(
    serviceVendorId: ServiceVendorId,
    employeeId: EmployeeId,
    externalReservationId: ExternalReservationId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/employees/${encodeURIComponent(`${employeeId}`)}/external-reservations/${encodeURIComponent(`${externalReservationId}`)}`;

    return axios.request<unknown>({
      url: url,
      method: 'DELETE',
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param noteId
   */
  deleteInternalNoteEndpoint(serviceVendorId: ServiceVendorId, noteId: InternalNoteId, $config?: AxiosRequestConfig): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/internal-notes/${encodeURIComponent(`${noteId}`)}`;

    return axios.request<unknown>({
      url: url,
      method: 'DELETE',
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param employeeId
   * @param employeeScheduleId
   */
  deleteScheduleEndpoint(
    serviceVendorId: ServiceVendorId,
    employeeId: EmployeeId,
    employeeScheduleId: EmployeeScheduleId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/employees/${encodeURIComponent(`${employeeId}`)}/schedules/${encodeURIComponent(`${employeeScheduleId}`)}`;

    return axios.request<unknown>({
      url: url,
      method: 'DELETE',
      ...$config,
    });
  },

  /** @param serviceVendorId */
  deleteServiceVendorEndpoint(serviceVendorId: ServiceVendorId, $config?: AxiosRequestConfig): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}`;

    return axios.request<unknown>({
      url: url,
      method: 'DELETE',
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param photoId
   */
  deleteServiceVendorPhotoEndpoint(
    serviceVendorId: ServiceVendorId,
    photoId: ServiceVendorPhotoId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/photos/${encodeURIComponent(`${photoId}`)}`;

    return axios.request<unknown>({
      url: url,
      method: 'DELETE',
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param serviceVendorServiceId
   */
  deleteServiceVendorServiceEndpoint(
    serviceVendorId: ServiceVendorId,
    serviceVendorServiceId: ServiceVendorServiceId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/services/${encodeURIComponent(`${serviceVendorServiceId}`)}`;

    return axios.request<unknown>({
      url: url,
      method: 'DELETE',
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param employeeId
   * @param timeOffId
   */
  deleteTimeOffEndpoint(
    serviceVendorId: ServiceVendorId,
    employeeId: EmployeeId,
    timeOffId: EmployeeTimeOffId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/employees/${encodeURIComponent(`${employeeId}`)}/time-offs/${encodeURIComponent(`${timeOffId}`)}`;

    return axios.request<unknown>({
      url: url,
      method: 'DELETE',
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param employeeId
   */
  disconnectGoogleCalendarEndpoint(serviceVendorId: ServiceVendorId, employeeId: EmployeeId, $config?: AxiosRequestConfig): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/employees/${encodeURIComponent(`${employeeId}`)}/calendar`;

    return axios.request<unknown>({
      url: url,
      method: 'DELETE',
      ...$config,
    });
  },

  /** @param serviceVendorId */
  getBusinessHoursEndpoint(serviceVendorId: ServiceVendorId, $config?: AxiosRequestConfig): AxiosPromise<GetBusinessHoursResponse> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/business-hours`;

    return axios.request<GetBusinessHoursResponse>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param employeeId
   * @param month
   * @param year
   */
  getCalendarReservationsEndpoint(
    serviceVendorId: ServiceVendorId,
    employeeId: EmployeeId,
    month: number,
    year: number,
    $config?: AxiosRequestConfig
  ): AxiosPromise<GetCalendarReservationsResponse> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/calendar/reservations`;

    return axios.request<GetCalendarReservationsResponse>({
      url: url,
      method: 'GET',
      params: {
        employeeId: employeeId,
        month: month,
        year: year,
      },
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param employeeId
   */
  getEmployeeCalendarStatusEndpoint(
    serviceVendorId: ServiceVendorId,
    employeeId: EmployeeId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<EmployeeCalendarStatusResponse> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/employees/${encodeURIComponent(`${employeeId}`)}/calendar`;

    return axios.request<EmployeeCalendarStatusResponse>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /** @param serviceVendorId */
  getEmployeesEndpoint(serviceVendorId: ServiceVendorId, $config?: AxiosRequestConfig): AxiosPromise<GetEmployeesResponse> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/employees`;

    return axios.request<GetEmployeesResponse>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param employeeId
   * @param externalReservationId
   */
  getExternalReservationEndpoint(
    serviceVendorId: string,
    employeeId: string,
    externalReservationId: ExternalReservationId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<GetExternalReservationResponse> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/employees/${encodeURIComponent(`${employeeId}`)}/external-reservations/${encodeURIComponent(`${externalReservationId}`)}`;

    return axios.request<GetExternalReservationResponse>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param page
   * @param elements
   * @param fromDate (optional)
   * @param toDate (optional)
   * @param serviceId (optional)
   * @param employeeId (optional)
   */
  getExternalReservationsEndpoint(
    serviceVendorId: ServiceVendorId,
    page: number,
    elements: number,
    fromDate?: Date | null,
    toDate?: Date | null,
    serviceId?: ServiceVendorServiceId | null,
    employeeId?: EmployeeId | null,
    $config?: AxiosRequestConfig
  ): AxiosPromise<GetExternalReservationsResponse> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/external-reservations`;

    return axios.request<GetExternalReservationsResponse>({
      url: url,
      method: 'GET',
      params: {
        page: page,
        elements: elements,
        fromDate: fromDate,
        toDate: toDate,
        serviceId: serviceId,
        employeeId: employeeId,
      },
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param noteId
   */
  getInternalNoteEndpoint(
    serviceVendorId: ServiceVendorId,
    noteId: InternalNoteId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<GetInternalNoteResponse> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/internal-notes/${encodeURIComponent(`${noteId}`)}`;

    return axios.request<GetInternalNoteResponse>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param petId
   */
  getInternalNotesEndpoint(serviceVendorId: ServiceVendorId, petId: PetId, $config?: AxiosRequestConfig): AxiosPromise<GetInternalNotesResponse> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/pets/${encodeURIComponent(`${petId}`)}/internal-notes`;

    return axios.request<GetInternalNotesResponse>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param reservationId
   */
  getReservationEndpoint(
    serviceVendorId: ServiceVendorId,
    reservationId: ReservationId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<GetReservationResponse> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/reservations/${encodeURIComponent(`${reservationId}`)}`;

    return axios.request<GetReservationResponse>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param page
   * @param elements
   * @param state (optional)
   * @param fromDate (optional)
   * @param toDate (optional)
   * @param serviceId (optional)
   * @param employeeId (optional)
   */
  getReservationsEndpoint(
    serviceVendorId: ServiceVendorId,
    page: number,
    elements: number,
    state?: string | null,
    fromDate?: Date | null,
    toDate?: Date | null,
    serviceId?: ServiceVendorServiceId | null,
    employeeId?: EmployeeId | null,
    $config?: AxiosRequestConfig
  ): AxiosPromise<GetReservationsResponse> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/reservations`;

    return axios.request<GetReservationsResponse>({
      url: url,
      method: 'GET',
      params: {
        page: page,
        elements: elements,
        state: state,
        fromDate: fromDate,
        toDate: toDate,
        serviceId: serviceId,
        employeeId: employeeId,
      },
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param employeeId
   * @param month (optional)
   * @param year (optional)
   */
  getSchedulesEndpoint(
    serviceVendorId: ServiceVendorId,
    employeeId: EmployeeId,
    month?: number | null,
    year?: number | null,
    $config?: AxiosRequestConfig
  ): AxiosPromise<GetSchedulesResponse> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/employees/${encodeURIComponent(`${employeeId}`)}/schedules`;

    return axios.request<GetSchedulesResponse>({
      url: url,
      method: 'GET',
      params: {
        month: month,
        year: year,
      },
      ...$config,
    });
  },

  /** @param serviceVendorId */
  getServiceVendorEndpoint(serviceVendorId: ServiceVendorId, $config?: AxiosRequestConfig): AxiosPromise<GetServiceVendorResponse> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}`;

    return axios.request<GetServiceVendorResponse>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /** @param serviceVendorId */
  getServiceVendorServicesEndpoint(serviceVendorId: ServiceVendorId, $config?: AxiosRequestConfig): AxiosPromise<GetServiceVendorServicesResponse> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/services`;

    return axios.request<GetServiceVendorServicesResponse>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /**
   * @param serviceTypeId (optional)
   * @param name (optional)
   * @param page
   * @param elements
   */
  getServiceVendorsEndpoint(
    serviceTypeId: ServiceTypeId | null | undefined,
    name: string | null | undefined,
    page: number,
    elements: number,
    $config?: AxiosRequestConfig
  ): AxiosPromise<GetServiceVendorsResponse> {
    const url = `/api/service-vendors`;

    return axios.request<GetServiceVendorsResponse>({
      url: url,
      method: 'GET',
      params: {
        serviceTypeId: serviceTypeId,
        name: name,
        page: page,
        elements: elements,
      },
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param employeeId
   * @param month (optional)
   * @param year (optional)
   */
  getTimeOffsEndpoint(
    serviceVendorId: ServiceVendorId,
    employeeId: EmployeeId,
    month?: number | null,
    year?: number | null,
    $config?: AxiosRequestConfig
  ): AxiosPromise<GetTimeOffsResponse> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/employees/${encodeURIComponent(`${employeeId}`)}/time-offs`;

    return axios.request<GetTimeOffsResponse>({
      url: url,
      method: 'GET',
      params: {
        month: month,
        year: year,
      },
      ...$config,
    });
  },

  /**
   * @param createBusinessHoursRequest (API name: CreateBusinessHoursRequest)
   * @param serviceVendorId
   */
  postBusinessHoursEndpoint(
    createBusinessHoursRequest: CreateBusinessHoursRequest,
    serviceVendorId: ServiceVendorId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<ServiceVendorBusinessHoursId> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/business-hours`;

    return axios.request<ServiceVendorBusinessHoursId>({
      url: url,
      method: 'POST',
      data: createBusinessHoursRequest,
      ...$config,
    });
  },

  /**
   * @param createEmployeeRequest (API name: CreateEmployeeRequest)
   * @param serviceVendorId
   */
  postEmployeeEndpoint(
    createEmployeeRequest: CreateEmployeeRequest,
    serviceVendorId: ServiceVendorId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<EmployeeId> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/employees`;

    return axios.request<EmployeeId>({
      url: url,
      method: 'POST',
      data: createEmployeeRequest,
      ...$config,
    });
  },

  /**
   * @param createExternalReservationRequest (API name: CreateExternalReservationRequest)
   * @param serviceVendorId
   * @param employeeId
   */
  postExternalReservationEndpoint(
    createExternalReservationRequest: CreateExternalReservationRequest,
    serviceVendorId: ServiceVendorId,
    employeeId: EmployeeId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<ExternalReservationId> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/employees/${encodeURIComponent(`${employeeId}`)}/external-reservations`;

    return axios.request<ExternalReservationId>({
      url: url,
      method: 'POST',
      data: createExternalReservationRequest,
      ...$config,
    });
  },

  /**
   * @param createInternalNoteRequest (API name: CreateInternalNoteRequest)
   * @param serviceVendorId
   */
  postInternalNoteEndpoint(
    createInternalNoteRequest: CreateInternalNoteRequest,
    serviceVendorId: ServiceVendorId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<InternalNoteId> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/internal-notes`;

    return axios.request<InternalNoteId>({
      url: url,
      method: 'POST',
      data: createInternalNoteRequest,
      ...$config,
    });
  },

  /**
   * @param createScheduleRequest (API name: CreateScheduleRequest)
   * @param serviceVendorId
   * @param employeeId
   */
  postScheduleEndpoint(
    createScheduleRequest: CreateScheduleRequest,
    serviceVendorId: ServiceVendorId,
    employeeId: EmployeeId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<EmployeeScheduleId> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/employees/${encodeURIComponent(`${employeeId}`)}/schedules`;

    return axios.request<EmployeeScheduleId>({
      url: url,
      method: 'POST',
      data: createScheduleRequest,
      ...$config,
    });
  },

  /** @param createServiceVendorRequest (API name: CreateServiceVendorRequest) */
  postServiceVendorEndpoint(createServiceVendorRequest: CreateServiceVendorRequest, $config?: AxiosRequestConfig): AxiosPromise<ServiceVendorId> {
    const url = `/api/service-vendors`;

    return axios.request<ServiceVendorId>({
      url: url,
      method: 'POST',
      data: createServiceVendorRequest,
      ...$config,
    });
  },

  /**
   * @param uploadServiceVendorPhotoRequest (API name: UploadServiceVendorPhotoRequest)
   * @param serviceVendorId
   */
  postServiceVendorPhotoEndpoint(
    uploadServiceVendorPhotoRequest: FormData,
    serviceVendorId: ServiceVendorId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<ServiceVendorPhotoId> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/photos`;

    return axios.request<ServiceVendorPhotoId>({
      url: url,
      method: 'POST',
      data: uploadServiceVendorPhotoRequest,
      ...$config,
    });
  },

  /**
   * @param createServiceVendorServiceRequest (API name: CreateServiceVendorServiceRequest)
   * @param serviceVendorId
   */
  postServiceVendorServiceEndpoint(
    createServiceVendorServiceRequest: CreateServiceVendorServiceRequest,
    serviceVendorId: ServiceVendorId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<ServiceVendorServiceId> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/services`;

    return axios.request<ServiceVendorServiceId>({
      url: url,
      method: 'POST',
      data: createServiceVendorServiceRequest,
      ...$config,
    });
  },

  /**
   * @param createTimeOffRequest (API name: CreateTimeOffRequest)
   * @param serviceVendorId
   * @param employeeId
   */
  postTimeOffEndpoint(
    createTimeOffRequest: CreateTimeOffRequest,
    serviceVendorId: ServiceVendorId,
    employeeId: EmployeeId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<EmployeeTimeOffId> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/employees/${encodeURIComponent(`${employeeId}`)}/time-offs`;

    return axios.request<EmployeeTimeOffId>({
      url: url,
      method: 'POST',
      data: createTimeOffRequest,
      ...$config,
    });
  },

  /**
   * @param updateBusinessHoursRequest (API name: UpdateBusinessHoursRequest)
   * @param serviceVendorId
   * @param businessHoursId
   */
  putBusinessHoursEndpoint(
    updateBusinessHoursRequest: UpdateBusinessHoursRequest,
    serviceVendorId: string,
    businessHoursId: string,
    $config?: AxiosRequestConfig
  ): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/business-hours/${encodeURIComponent(`${businessHoursId}`)}`;

    return axios.request<unknown>({
      url: url,
      method: 'PUT',
      data: updateBusinessHoursRequest,
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param reservationId
   */
  putConfirmReservationEndpoint(serviceVendorId: string, reservationId: string, $config?: AxiosRequestConfig): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/reservations/${encodeURIComponent(`${reservationId}`)}/confirm`;

    return axios.request<unknown>({
      url: url,
      method: 'PUT',
      ...$config,
    });
  },

  /**
   * @param updateEmployeeRequest (API name: UpdateEmployeeRequest)
   * @param serviceVendorId
   * @param employeeId
   */
  putEmployeeEndpoint(
    updateEmployeeRequest: UpdateEmployeeRequest,
    serviceVendorId: string,
    employeeId: string,
    $config?: AxiosRequestConfig
  ): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/employees/${encodeURIComponent(`${employeeId}`)}`;

    return axios.request<unknown>({
      url: url,
      method: 'PUT',
      data: updateEmployeeRequest,
      ...$config,
    });
  },

  /**
   * @param updateInternalNoteRequest (API name: UpdateInternalNoteRequest)
   * @param serviceVendorId
   * @param noteId
   */
  putInternalNoteEndpoint(
    updateInternalNoteRequest: UpdateInternalNoteRequest,
    serviceVendorId: string,
    noteId: string,
    $config?: AxiosRequestConfig
  ): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/internal-notes/${encodeURIComponent(`${noteId}`)}`;

    return axios.request<unknown>({
      url: url,
      method: 'PUT',
      data: updateInternalNoteRequest,
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param reservationId
   */
  putMarkNoShowReservationEndpoint(serviceVendorId: string, reservationId: string, $config?: AxiosRequestConfig): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/reservations/${encodeURIComponent(`${reservationId}`)}/no-show`;

    return axios.request<unknown>({
      url: url,
      method: 'PUT',
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param reservationId
   */
  putRejectReservationEndpoint(serviceVendorId: string, reservationId: string, $config?: AxiosRequestConfig): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/reservations/${encodeURIComponent(`${reservationId}`)}/reject`;

    return axios.request<unknown>({
      url: url,
      method: 'PUT',
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param employeeId
   */
  putRestoreEmployeeEndpoint(serviceVendorId: string, employeeId: string, $config?: AxiosRequestConfig): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/employees/${encodeURIComponent(`${employeeId}`)}/restore`;

    return axios.request<unknown>({
      url: url,
      method: 'PUT',
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param serviceVendorServiceId
   */
  putRestoreServiceVendorServiceEndpoint(
    serviceVendorId: string,
    serviceVendorServiceId: string,
    $config?: AxiosRequestConfig
  ): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/services/${encodeURIComponent(`${serviceVendorServiceId}`)}/restore`;

    return axios.request<unknown>({
      url: url,
      method: 'PUT',
      ...$config,
    });
  },

  /**
   * @param updateScheduleRequest (API name: UpdateScheduleRequest)
   * @param serviceVendorId
   * @param employeeId
   * @param employeeScheduleId
   */
  putScheduleEndpoint(
    updateScheduleRequest: UpdateScheduleRequest,
    serviceVendorId: string,
    employeeId: string,
    employeeScheduleId: string,
    $config?: AxiosRequestConfig
  ): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/employees/${encodeURIComponent(`${employeeId}`)}/schedules/${encodeURIComponent(`${employeeScheduleId}`)}`;

    return axios.request<unknown>({
      url: url,
      method: 'PUT',
      data: updateScheduleRequest,
      ...$config,
    });
  },

  /**
   * @param updateServiceVendorRequest (API name: UpdateServiceVendorRequest)
   * @param id
   */
  putServiceVendorEndpoint(updateServiceVendorRequest: UpdateServiceVendorRequest, id: string, $config?: AxiosRequestConfig): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${id}`)}`;

    return axios.request<unknown>({
      url: url,
      method: 'PUT',
      data: updateServiceVendorRequest,
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param photoId
   */
  putServiceVendorPhotoAsProfileEndpoint(serviceVendorId: string, photoId: string, $config?: AxiosRequestConfig): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/photos/${encodeURIComponent(`${photoId}`)}/set-as-profile`;

    return axios.request<unknown>({
      url: url,
      method: 'PUT',
      ...$config,
    });
  },

  /**
   * @param updateServiceVendorServiceRequest (API name: UpdateServiceVendorServiceRequest)
   * @param serviceVendorId
   * @param serviceVendorServiceId
   */
  putServiceVendorServiceEndpoint(
    updateServiceVendorServiceRequest: UpdateServiceVendorServiceRequest,
    serviceVendorId: string,
    serviceVendorServiceId: string,
    $config?: AxiosRequestConfig
  ): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/services/${encodeURIComponent(`${serviceVendorServiceId}`)}`;

    return axios.request<unknown>({
      url: url,
      method: 'PUT',
      data: updateServiceVendorServiceRequest,
      ...$config,
    });
  },

  /**
   * @param updateTimeOffRequest (API name: UpdateTimeOffRequest)
   * @param serviceVendorId
   * @param employeeId
   * @param timeOffId
   */
  putTimeOffEndpoint(
    updateTimeOffRequest: UpdateTimeOffRequest,
    serviceVendorId: string,
    employeeId: string,
    timeOffId: string,
    $config?: AxiosRequestConfig
  ): AxiosPromise<unknown> {
    const url = `/api/service-vendors/${encodeURIComponent(`${serviceVendorId}`)}/employees/${encodeURIComponent(`${employeeId}`)}/time-offs/${encodeURIComponent(`${timeOffId}`)}`;

    return axios.request<unknown>({
      url: url,
      method: 'PUT',
      data: updateTimeOffRequest,
      ...$config,
    });
  },
};

export const reservationsClient = {
  /** @param reservationId */
  getReservationMedicalDocumentsEndpoint(
    reservationId: ReservationId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<GetReservationMedicalDocumentsResponse> {
    const url = `/api/reservations/${encodeURIComponent(`${reservationId}`)}/medical-documents`;

    return axios.request<GetReservationMedicalDocumentsResponse>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /** @param reservationId */
  getReservationPetHealthProfileEndpoint(
    reservationId: ReservationId,
    $config?: AxiosRequestConfig
  ): AxiosPromise<GetReservationPetHealthProfileResponse> {
    const url = `/api/reservations/${encodeURIComponent(`${reservationId}`)}/pet-health-profile`;

    return axios.request<GetReservationPetHealthProfileResponse>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
};

export const placesClient = {
  /** @param placeId */
  getPlaceDetailsEndpoint(placeId: string, $config?: AxiosRequestConfig): AxiosPromise<GetPlaceDetailsResponse> {
    const url = `/api/places/details`;

    return axios.request<GetPlaceDetailsResponse>({
      url: url,
      method: 'GET',
      params: {
        placeId: placeId,
      },
      ...$config,
    });
  },

  /** @param input */
  getPlacesAutocompleteEndpoint(input: string, $config?: AxiosRequestConfig): AxiosPromise<GetPlacesAutocompleteResponse> {
    const url = `/api/places/autocomplete`;

    return axios.request<GetPlacesAutocompleteResponse>({
      url: url,
      method: 'GET',
      params: {
        input: input,
      },
      ...$config,
    });
  },
};

export const notificationsClient = {
  /**
   * @param page
   * @param elements
   */
  getNotificationsEndpoint(page: number, elements: number, $config?: AxiosRequestConfig): AxiosPromise<GetNotificationsResponse> {
    const url = `/api/notifications`;

    return axios.request<GetNotificationsResponse>({
      url: url,
      method: 'GET',
      params: {
        page: page,
        elements: elements,
      },
      ...$config,
    });
  },

  getUnreadNotificationsCountEndpoint($config?: AxiosRequestConfig): AxiosPromise<GetUnreadNotificationsCountResponse> {
    const url = `/api/notifications/unread-count`;

    return axios.request<GetUnreadNotificationsCountResponse>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /** @param notificationId */
  putNotificationReadEndpoint(notificationId: string, $config?: AxiosRequestConfig): AxiosPromise<unknown> {
    const url = `/api/notifications/${encodeURIComponent(`${notificationId}`)}/read`;

    return axios.request<unknown>({
      url: url,
      method: 'PUT',
      ...$config,
    });
  },
};

export const homeClient = {
  /**
   * @param serviceVendorId
   * @param weekStart
   */
  getWeeklyCalendarEndpoint(
    serviceVendorId: ServiceVendorId,
    weekStart: Date,
    $config?: AxiosRequestConfig
  ): AxiosPromise<GetWeeklyCalendarResponse> {
    const url = `/api/home/${encodeURIComponent(`${serviceVendorId}`)}/weekly-calendar`;

    return axios.request<GetWeeklyCalendarResponse>({
      url: url,
      method: 'GET',
      params: {
        weekStart: weekStart,
      },
      ...$config,
    });
  },

  /**
   * @param serviceVendorId
   * @param weekStart
   */
  getWeeklySummaryEndpoint(serviceVendorId: ServiceVendorId, weekStart: Date, $config?: AxiosRequestConfig): AxiosPromise<GetWeeklySummaryResponse> {
    const url = `/api/home/${encodeURIComponent(`${serviceVendorId}`)}/weekly-summary`;

    return axios.request<GetWeeklySummaryResponse>({
      url: url,
      method: 'GET',
      params: {
        weekStart: weekStart,
      },
      ...$config,
    });
  },
};

export const serviceTypesClient = {
  getServiceTypesEndpoint($config?: AxiosRequestConfig): AxiosPromise<GetServiceTypesResponse> {
    const url = `/api/service-types`;

    return axios.request<GetServiceTypesResponse>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
};

/**
 * Serializes a params object into a query string that is compatible with different REST APIs.
 * Implementation from: https://github.com/suhaotian/xior/blob/main/src/utils.ts
 * Kudos to @suhaotian for the original implementation
 */
function encodeParams<T = any>(
  params: T,
  parentKey: string | null = null,
  options?: {
    allowDots?: boolean;
    serializeDate?: (value: Date) => string;
    arrayFormat?: 'indices' | 'repeat' | 'brackets';
  }
): string {
  if (params === undefined || params === null) return '';
  const encodedParams: string[] = [];
  const paramsIsArray = Array.isArray(params);
  const { arrayFormat, allowDots, serializeDate } = options || {};

  const getKey = (key: string) => {
    if (allowDots && !paramsIsArray) return `.${key}`;
    if (paramsIsArray) {
      if (arrayFormat === 'brackets') {
        return '[]';
      }
      if (arrayFormat === 'repeat') {
        return '';
      }
    }
    return `[${key}]`;
  };

  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      let value = (params as any)[key];
      if (value !== undefined) {
        const encodedKey = parentKey ? `${parentKey}${getKey(key)}` : (key as string);

        // biome-ignore lint/suspicious/noGlobalIsNan: <explanation>
        if (!isNaN(value) && value instanceof Date) {
          value = serializeDate ? serializeDate(value) : value.toISOString();
        }
        if (typeof value === 'object') {
          // If the value is an object or array, recursively encode its contents
          const result = encodeParams(value, encodedKey, options);
          if (result !== '') encodedParams.push(result);
        } else {
          // Otherwise, encode the key-value pair
          encodedParams.push(`${encodeURIComponent(encodedKey)}=${encodeURIComponent(value)}`);
        }
      }
    }
  }

  return encodedParams.join('&');
}

export interface CreatePortalSessionResponse {
  portalUrl?: string;
}

/** the dto used to send an error response to the client when an unhandled exception occurs on the server */
export interface InternalErrorResponse {
  /** error status */
  status?: string;
  /** http status code of the error response */
  code?: number;
  /** the reason for the error */
  reason?: string;
  /** additional information or instructions */
  note?: string;
}

export interface CreatePortalSessionRequest extends GetRequestBase {
  returnUrl?: string;
}

export interface ServiceVendorId {}

export interface GetRequestBase extends RequestBase {}

export interface RequestBase {}

/** the dto used to send an error response to the client */
export interface ErrorResponse {
  /** the http status code sent to the client. default is 400. */
  statusCode?: number;
  /** the message for the error response */
  message?: string;
  /** the collection of errors for the current context */
  errors?: { [key: string]: string[] };
}

export interface GetPricingConfigResponse {
  pricingTableId?: string;
  publishableKey?: string;
  customerSessionClientSecret?: string;
}

export interface GetVendorSubscriptionResponse {
  plan?: string;
  state?: string;
  employeeLimit?: number;
  currentPeriodEnd?: Date;
  canAcceptReservations?: boolean;
}

export interface GetServiceVendorResponse {
  serviceVendor?: ServiceVendorDetailsDto;
}

export interface ServiceVendorDetailsDto {
  id?: ServiceVendorId;
  name?: string;
  street?: string;
  city?: string;
  postalCode?: string;
  fullAddress?: string;
  phone?: string;
  email?: string;
  website?: string;
  services?: ServiceVendorServiceDto[];
  latitude?: number;
  longitude?: number;
  serviceTypeId?: ServiceTypeId;
  serviceTypeName?: string;
  serviceTypeCode?: string;
  serviceTypeIcon?: string;
  photos?: ServiceVendorPhotoDto[];
  isActive?: boolean;
  canConfigureServices?: boolean;
  canHandleServiceReservations?: boolean;
  description?: string;
}

export interface ServiceVendorServiceDto {
  id?: ServiceVendorServiceId;
  name?: string;
  durationMinutes?: number;
  price?: number;
  isPriceFrom?: boolean;
  isActive?: boolean;
}

export interface ServiceVendorServiceId {}

export interface ServiceTypeId {}

export interface ServiceVendorPhotoDto {
  id?: ServiceVendorPhotoId;
  blobUrl?: string;
  fileName?: string;
  contentType?: string;
  size?: number;
  isProfilePhoto?: boolean;
}

export interface ServiceVendorPhotoId {}

export interface GetServiceVendorsResponse {
  serviceVendors?: ServiceVendorDto[];
}

export interface ServiceVendorDto {
  id?: ServiceVendorId;
  name?: string;
  displayAddress?: string;
  phone?: string;
  email?: string;
  website?: string;
  latitude?: number;
  longitude?: number;
  serviceTypeId?: ServiceTypeId;
  serviceTypeName?: string;
  canConfigureServices?: boolean;
  canHandleServiceReservations?: boolean;
  canSeeHealthData?: boolean;
  isActive?: boolean;
  profilePhotoUrl?: string;
}

export interface CreateServiceVendorRequest extends PostRequestBase {
  name?: string;
  street?: string;
  city?: string;
  postalCode?: string;
  phone?: string;
  email?: string;
  serviceTypeId?: ServiceTypeId;
  latitude?: number;
  longitude?: number;
  acceptsTerms?: boolean;
  acceptsRepresentation?: boolean;
  acceptsMarketing?: boolean;
  website?: string;
  description?: string;
}

export interface PostRequestBase extends RequestBase {}

export interface UpdateServiceVendorRequest extends PutRequestBase {
  name?: string;
  street?: string;
  city?: string;
  postalCode?: string;
  phone?: string;
  email?: string;
  latitude?: number;
  longitude?: number;
  website?: string;
  description?: string;
}

export interface PutRequestBase extends RequestBase {}

export interface GetServiceVendorServicesResponse {
  services?: ServiceVendorServiceDto[];
}

export interface CreateServiceVendorServiceRequest extends PostRequestBase {
  name?: string;
  durationMinutes?: number;
  price?: number;
  isPriceFrom?: boolean;
}

export interface UpdateServiceVendorServiceRequest extends PutRequestBase {
  name?: string;
  durationMinutes?: number;
  price?: number;
  isPriceFrom?: boolean;
}

export interface UploadServiceVendorPhotoRequest extends PostRequestBase {
  setAsProfile?: boolean;
}

export interface InternalNoteId {}

export interface GetInternalNoteResponse {
  note?: InternalNoteDto;
}

export interface InternalNoteDto {
  id?: InternalNoteId;
  clientProfileId?: ClientProfileId;
  petId?: PetId;
  body?: string;
  created?: Date;
}

export interface ClientProfileId {}

export interface PetId {}

export interface GetInternalNotesResponse {
  notes?: InternalNoteDto[];
}

export interface CreateInternalNoteRequest extends PostRequestBase {
  clientProfileId?: ClientProfileId;
  petId?: PetId;
  body?: string;
}

export interface UpdateInternalNoteRequest extends PutRequestBase {
  body?: string;
}

export interface EmployeeId {}

export interface GetEmployeesResponse {
  employees?: EmployeeDto[];
}

export interface EmployeeDto {
  id?: EmployeeId;
  firstName?: string;
  lastName?: string;
  position?: string;
  isActive?: boolean;
  deactivationReason?: string;
}

export interface CreateEmployeeRequest extends PostRequestBase {
  firstName?: string;
  lastName?: string;
  position?: string;
}

export interface UpdateEmployeeRequest extends PutRequestBase {
  firstName?: string;
  lastName?: string;
  position?: string;
}

export interface EmployeeTimeOffId {}

export interface GetTimeOffsResponse {
  timeOffs?: TimeOffDto[];
}

export interface TimeOffDto {
  id?: EmployeeTimeOffId;
  dateFrom?: Date;
  dateTo?: Date;
  reason?: string;
}

export interface CreateTimeOffRequest extends PostRequestBase {
  dateFrom?: Date;
  dateTo?: Date;
  reason?: string;
}

export interface UpdateTimeOffRequest extends PutRequestBase {
  dateFrom?: Date;
  dateTo?: Date;
  reason?: string;
}

export interface EmployeeScheduleId {}

export interface GetSchedulesResponse {
  schedules?: ScheduleDto[];
}

export interface ScheduleDto {
  id?: EmployeeScheduleId;
  validFrom?: Date;
  validTo?: Date;
  days?: ScheduleDayDto[];
  serviceIds?: ServiceVendorServiceId[];
}

export interface ScheduleDayDto {
  dayOfWeek?: DayOfWeek;
  timeRanges?: TimeRangeDto[];
}

export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export interface TimeRangeDto {
  startTime?: string;
  endTime?: string;
}

export interface CreateScheduleRequest extends PostRequestBase {
  validFrom?: Date;
  validTo?: Date;
  days?: ScheduleDayDefinitionDto[];
  serviceIds?: ServiceVendorServiceId[];
}

export interface ScheduleDayDefinitionDto {
  dayOfWeek?: DayOfWeek;
  blocks?: TimeRangeDto[];
}

export interface UpdateScheduleRequest extends PutRequestBase {
  validFrom?: Date;
  validTo?: Date;
  days?: ScheduleDayDefinitionDto[];
  serviceIds?: ServiceVendorServiceId[];
}

export interface ExternalReservationId {}

export interface GetExternalReservationResponse {
  externalReservation?: ExternalReservationDetailsDto;
}

export interface ExternalReservationDetailsDto {
  id?: ExternalReservationId;
  employeeId?: EmployeeId;
  employeeName?: string;
  serviceId?: ServiceVendorServiceId;
  serviceName?: string;
  durationMinutes?: number;
  price?: number;
  date?: Date;
  startTime?: string;
  endTime?: string;
  clientFirstName?: string;
  clientLastName?: string;
  clientEmail?: string;
  clientPhone?: string;
  note?: string;
}

export interface CreateExternalReservationRequest extends PostRequestBase {
  serviceVendorServiceId?: ServiceVendorServiceId;
  date?: Date;
  startTime?: string;
  clientFirstName?: string;
  clientLastName?: string;
  clientEmail?: string;
  clientPhone?: string;
  note?: string;
}

export interface ConnectGoogleCalendarResponse {
  authorizationUrl?: string;
}

export interface EmployeeCalendarStatusResponse {
  isConnected?: boolean;
  accountEmail?: string;
  calendarId?: string;
  status?: string;
  revokeReason?: string;
  lastSyncedAtUtc?: Date;
}

export interface ServiceVendorBusinessHoursId {}

export interface GetBusinessHoursResponse {
  businessHours?: BusinessHoursDto[];
}

export interface BusinessHoursDto {
  id?: ServiceVendorBusinessHoursId;
  dayOfWeek?: DayOfWeek;
  is24Hours?: boolean;
  startTime?: string;
  endTime?: string;
  isActive?: boolean;
}

export interface CreateBusinessHoursRequest extends PostRequestBase {
  dayOfWeek?: DayOfWeek;
  is24Hours?: boolean;
  startTime?: string;
  endTime?: string;
}

export interface UpdateBusinessHoursRequest extends PutRequestBase {
  is24Hours?: boolean;
  startTime?: string;
  endTime?: string;
}

export interface GetCalendarReservationsResponse {
  reservations?: CalendarReservationDto[];
  blocks?: CalendarBlockDto[];
}

export interface CalendarReservationDto {
  id?: string;
  serviceName?: string;
  date?: Date;
  startTime?: string;
  endTime?: string;
  state?: string;
  type?: string;
}

export interface CalendarBlockDto {
  id?: string;
  date?: Date;
  startTime?: string;
  endTime?: string;
}

export interface GetExternalReservationsResponse {
  reservations?: ExternalReservationListDto[];
}

export interface ExternalReservationListDto {
  id?: string;
  clientFirstName?: string;
  clientLastName?: string;
  serviceId?: ServiceVendorServiceId;
  serviceName?: string;
  date?: Date;
  startTime?: string;
  endTime?: string;
  price?: number;
  notes?: string;
  employeeId?: EmployeeId;
  employeeName?: string;
}

export interface GetReservationResponse {
  reservation?: ReservationDetailsDto;
}

export interface ReservationDetailsDto {
  id?: ReservationId;
  petId?: PetId;
  petName?: string;
  petSpeciesName?: string;
  serviceId?: ServiceVendorServiceId;
  serviceName?: string;
  durationMinutes?: number;
  price?: number;
  date?: Date;
  startTime?: string;
  endTime?: string;
  state?: string;
  notes?: string;
  employeeId?: EmployeeId;
  employeeName?: string;
  noShowPercentage?: number;
  noShowCount?: number;
  resolvedCount?: number;
  clientProfileId?: ClientProfileId;
  clientFullName?: string;
  clientPhone?: string;
}

export interface ReservationId {}

export interface GetReservationsResponse {
  reservations?: ReservationDto[];
}

export interface ReservationDto {
  id?: ReservationId;
  serviceId?: ServiceVendorServiceId;
  serviceName?: string;
  date?: Date;
  startTime?: string;
  endTime?: string;
  price?: number;
  state?: string;
  notes?: string;
  employeeId?: EmployeeId;
  employeeName?: string;
  clientFullName?: string;
}

export interface GetReservationPetHealthProfileResponse {
  latestWeight?: WeightEntryDto;
  weightHistory?: WeightEntryDto[];
  allergies?: AllergyDto[];
  sterilization?: SterilizationStatus;
  microchipNumber?: string;
  vaccinations?: VaccinationDto[];
  dewormings?: DewormingDto[];
  medications?: MedicationScheduleDto[];
}

export interface WeightEntryDto {
  weight?: number;
  measuredOn?: Date;
  note?: string;
}

export interface AllergyDto {
  name?: string;
}

export enum SterilizationStatus {
  Unknown = 0,
  Yes = 1,
  No = 2,
}

export interface VaccinationDto {
  id?: VaccinationId;
  productId?: VaccineProductId;
  productName?: string;
  number?: string;
  performedOn?: Date;
  nextDueOn?: Date;
  note?: string;
}

export interface VaccinationId {}

export interface VaccineProductId {}

export interface DewormingDto {
  id?: DewormingId;
  performedOn?: Date;
  nextDueOn?: Date;
  note?: string;
}

export interface DewormingId {}

export interface MedicationScheduleDto {
  id?: MedicationScheduleId;
  name?: string;
  startDate?: Date;
  endDate?: Date;
  doseAmount?: number;
  doseUnit?: string;
  reminderTimes?: string[];
  note?: string;
  isActive?: boolean;
}

export interface MedicationScheduleId {}

export interface GetReservationMedicalDocumentsResponse {
  documents?: MedicalDocumentDto[];
}

export interface MedicalDocumentDto {
  id?: MedicalDocumentId;
  fileName?: string;
  blobUrl?: string;
  contentType?: string;
  sizeInBytes?: number;
  categoryId?: MedicalDocumentCategoryId;
  documentDate?: Date;
  note?: string;
}

export interface MedicalDocumentId {}

export interface MedicalDocumentCategoryId {}

export interface GetPlaceDetailsResponse {
  latitude?: number;
  longitude?: number;
  street?: string;
  city?: string;
  postalCode?: string;
}

export interface GetPlacesAutocompleteResponse {
  suggestions?: PlaceSuggestionDto[];
}

export interface PlaceSuggestionDto {
  description?: string;
  placeId?: string;
}

export interface GetNotificationsResponse {
  notifications?: NotificationDto[];
}

export interface NotificationDto {
  id?: NotificationId;
  channel?: string;
  type?: string;
  title?: string;
  body?: string;
  state?: string;
  sentAt?: Date;
  readAt?: Date;
  created?: Date;
}

export interface NotificationId {}

export interface GetUnreadNotificationsCountResponse {
  count?: number;
}

export interface GetWeeklyCalendarResponse {
  reservations?: WeeklyCalendarReservationDto[];
  blocks?: WeeklyCalendarBlockDto[];
}

export interface WeeklyCalendarReservationDto {
  id?: string;
  serviceName?: string;
  date?: Date;
  startTime?: string;
  endTime?: string;
  state?: string;
  type?: string;
  employeeId?: EmployeeId;
  employeeName?: string;
  petName?: string;
  clientName?: string;
}

export interface WeeklyCalendarBlockDto {
  id?: string;
  date?: Date;
  startTime?: string;
  endTime?: string;
  employeeId?: EmployeeId;
  employeeName?: string;
}

export interface GetWeeklySummaryResponse {
  totalReservations?: number;
  pendingCount?: number;
  confirmedCount?: number;
  cancelledCount?: number;
  rejectedCount?: number;
  externalCount?: number;
  weekRevenue?: number;
  todayReservationCount?: number;
  employees?: EmployeeDaySummaryDto[];
}

export interface EmployeeDaySummaryDto {
  employeeId?: EmployeeId;
  employeeName?: string;
  todayReservationCount?: number;
  weekReservationCount?: number;
}

export interface GetServiceTypesResponse {
  serviceTypes?: ServiceTypeDto[];
}

export interface ServiceTypeDto {
  id?: ServiceTypeId;
  name?: string;
  code?: string;
  description?: string;
  icon?: string;
  isActive?: boolean;
}
